// extracted by mini-css-extract-plugin
module.exports = {"shop":"Shop_shop__1poZ_","title":"Shop_title__arksq","girl":"Shop_girl__I2SsO","text":"Shop_text__1PAYS"};